import Request from "../../../services/request";
import { SchemeNodePipe } from "@/helpers/constructors";

/**
 * Легенда цветовой кодировки трубопроводов (подача/обратка отопления, ГВС,
 * ХВС, канализация, газ и т.д.) — d_scheme_node_pipes.
 */

const API = "/dictionary/scheme-node-pipes";

export default {
  namespaced: true,
  state: {
    listEntries: [],
    loadingList: false,
    deleteModal: false,
    entry: new SchemeNodePipe(),
  },
  mutations: {
    setListEntries(state, array) {
      state.listEntries = Array.isArray(array) ? array : Object.values(array || {});
    },
    setEntry(state, object) {
      state.entry = object || new SchemeNodePipe();
    },
    clearEntry(state) {
      state.entry = new SchemeNodePipe();
    },
    changeLoadingList(state, value) {
      state.loadingList = value;
    },
    deleteModalCommit(state, value) {
      state.deleteModal = value;
    },
  },
  actions: {
    stateModalAction({ commit }, value) {
      commit("deleteModalCommit", value);
    },
    clearEntry({ commit }) {
      commit("clearEntry");
    },
    async getListEntries({ commit }) {
      commit("changeLoadingList", true);
      try {
        const query = Request.modifyQuery([], ["*"]);
        const response = await Request.get(
          this.state.BASE_URL + `${API}${query}`
        );
        if (response && !response.isError) {
          commit("setListEntries", response.data);
        }
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoadingList", false);
      }
    },
    async createEntry({ commit }, payload) {
      try {
        return await Request.post(this.state.BASE_URL + API, payload);
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },
    async updateEntry({ commit }, payload) {
      try {
        return await Request.put(
          this.state.BASE_URL + `${API}/${payload.id}`,
          payload
        );
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },
    async onSubmit({ commit, dispatch }, payload) {
      commit("changeLoadingList", true);
      try {
        const response = payload.id
          ? await dispatch("updateEntry", payload)
          : await dispatch("createEntry", payload);
        if (response && !response.isError) {
          await dispatch("getListEntries");
        }
        return response;
      } finally {
        commit("changeLoadingList", false);
      }
    },
    async deleteEntry({ commit, dispatch }, id) {
      commit("changeLoadingList", true);
      commit("deleteModalCommit", false);
      try {
        const response = await Request.delete(
          this.state.BASE_URL + `${API}/${id}`
        );
        if (response && !response.isError) {
          await dispatch("getListEntries");
        }
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoadingList", false);
      }
    },
  },
};
